import { useAuth } from "../components/Auth/UnifiedAuthProvider";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useFeatureFlag = (featureFlag: string) => {
  const { user } = useAuth();

  const allowedDomains = [
    "frontierxai.com",
    "frontierx.ai",
    "frontieracademy.ai",
    "stef.io",
    "imogen.io",
  ];

  return (
    (user?.email &&
      allowedDomains.some((domain) => user.email.endsWith(`@${domain}`))) ??
    false
  );
};
